<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <div class="flex w-96 flex-col items-center">
      <div>
        <m-completed-ring></m-completed-ring>
      </div>

      <div
        data-cy="emailIsConfirmedTitle"
        class="text-s2 mt-9 select-none text-2xl font-semibold"
        >{{ pageTitle }}</div
      >

      <button
        class="bg-m600 text-m0 mt-12 w-28 rounded py-3 font-medium focus:outline-none"
        (click)="ok()"
        >Ok</button
      >
    </div>
  </div>
</div>
